import { PaperPins } from "./QuestPaperDecor";

/** 掲載が少ないときの案内札。架空のQuestや募集予定として表示しません。 */
export function QuestBoardGuide() {
  return (
    <aside
      className="jq-board-guide jq-paper"
      aria-labelledby="quest-board-guide-title"
    >
      <PaperPins />
      <p className="jq-eyebrow">BOARD GUIDE / ご案内</p>
      <h2 id="quest-board-guide-title">
        その一歩が、
        <br />
        次の経験になる。
      </h2>
      <ol>
        <li>
          <span>01</span>
          <div>
            <strong>依頼書を開く</strong>
            <p>気になるQuestのMissionと条件を確認。</p>
          </div>
        </li>
        <li>
          <span>02</span>
          <div>
            <strong>自分で選んで応募</strong>
            <p>経験やスキルを添えてエントリー。</p>
          </div>
        </li>
        <li>
          <span>03</span>
          <div>
            <strong>企業が選考</strong>
            <p>条件を確認し、契約後に挑戦スタート。</p>
          </div>
        </li>
      </ol>
      <p className="jq-board-guide-note">
        Rankは依頼の難易度です。
        <br />
        あなたの能力ランクではありません。
      </p>
      <span className="jq-guide-signature" aria-hidden="true">
        AIYSS Job Quest
      </span>
    </aside>
  );
}
